import { useMutation } from '@gogame/query';

import { createParentCampaign } from 'scenes/Campaigns/sources/parentCampaigns';

import { create } from '../queryKeyFactory';

export const useCreateParentCampaign = () => {
  const createMutation = useMutation(create(), createParentCampaign, {
    successMessage: () => 'Campaign created',
  });

  const handleAction = async (campaign) => {
    const campaigns = await createMutation.mutateAsync(campaign);
    return { campaigns, multiCampaign: campaign };
  };

  return [handleAction, createMutation];
};
